module.exports = __webpack_public_path__ + "fonts/SofiaProUltraLight-Italic.ecd82f22.eot";